import { render, staticRenderFns } from "./SendMealIndex.vue?vue&type=template&id=bf262eb0"
import script from "./SendMealIndex.vue?vue&type=script&lang=js"
export * from "./SendMealIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports